import {Text, View, Image} from '@react-pdf/renderer';
import styles from '../styles';
import websiteIcon from '../../../assets/image/pdf/website_icon.svg';
import callCenterIcon from '../../../assets/image/pdf/call_center_icon.svg';
import emailIcon from '../../../assets/image/pdf/email_icon.svg';

const Footer: React.FC = ({}) => (
  <View style={styles.footer} fixed>
    <View style={styles.footerItem}>
      <Image source={websiteIcon} />
      <Text style={styles.footerText}>mazraeapp.com</Text>
    </View>

    <View style={styles.footerItem}>
      <Image source={emailIcon} />
      <Text style={styles.footerText}>info@mazraeapp.com</Text>
    </View>

    <View style={styles.footerItem}>
      <Image source={callCenterIcon} />
      <Text style={styles.footerText}>021 66401773</Text>
    </View>
  </View>
);

export default Footer;
